import axios from 'axios'

const axiosConfig = {
    baseURL: process.env.REACT_APP_API_ENDPOINT_NODE,
    headers: {
        common: {
            Authorization: localStorage.getItem('access_token')
                ? `Bearer ${localStorage.getItem('access_token')}`
                : false,
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        },
        post: {
            'Access-Control-Allow-Origin': '*'
        }
    }
}

// create axios custom instance with custom config
const axiosInstanceNode = axios.create(axiosConfig)

axiosInstanceNode.interceptors.request.use(request => {
    const token = localStorage.getItem('access_token')
    if (token) request.headers['Authorization'] = `Bearer ${token}`
    return request
})

axiosInstanceNode.interceptors.response.use(
    response => {
        // pass response without change
        return response
    },
    error => {
        // get error info
        const statusCode = error?.response?.status
        switch (statusCode) {
            case 401: {
                localStorage.removeItem('access_token')
                localStorage.removeItem('refresh_token')
                return Promise.reject(error)
            }
            default:
                return Promise.reject(error)
        }
    }
)

export default axiosInstanceNode
